import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Router } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { createBrowserHistory } from "history";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const history = createBrowserHistory();
ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Router history={history}>
      <App history={history} />
      {/* <App /> */}
    </Router>
  </BrowserRouter>,
  rootElement);

registerServiceWorker();

